module.exports = __webpack_public_path__ + "static/media/video-template.4238efb5.svg";